import i18n from "i18next";
import { initReactI18next } from "react-i18next";
import { mainBus } from "./core/EventBus";
import { SHELL_DATA_LOADED } from "./core/EventBus/constants";
//import coBrosweStrings from './features/cobrowse/strings';
// import loadingStrings from './features/loading/strings';
// import menuStrings from './features/menu/strings';
// import itemPanelStrings from './features/sidePanel/string';

import featureStrings from './features/strings';
let languages = {
  en: {
    translation: {

    }
  },
  fr: {
    translation: {

    }
  },
  tr:{
    translation: {

    }
  }
}

// the translations
// (tip move them in a JSON file and import them,
// or even better, manage them separated from your code: https://react.i18next.com/guides/multiple-translation-files)

Object.keys(languages).forEach(l => {
  languages[l].translation = {
    // ...coBrosweStrings[l].translation,
    // ...loadingStrings[l].translation,
    // ...menuStrings[l].translation,
    // ...itemPanelStrings[l].translation,
    ...featureStrings[l].translation
  }
})

const resources = languages;

i18n
.use(initReactI18next) // passes i18n down to react-i18next
.init({
  resources,
  lng: 'en', // language to use, more information here: https://www.i18next.com/overview/configuration-options#languages-namespaces-resources
  // you can use the i18n.changeLanguage function to change the language manually: https://www.i18next.com/overview/api#changelanguage
  // if you're using a language detector, do not define the lng option
  interpolation: {
    escapeValue: false // react already safes from xss
  }
});


export default i18n;